import { login,logout,getInfo} from '@/api/user'
import { getToken, setToken, removeToken,getUserId,setUserId,removeUserId } from '@/utils/auth'
import { verifyStrContain } from '@/utils/tool'

const state = {
    token: getToken(),
    name: '',
    isReg:false,
    roleName:'',
    roleId:'',
    isAleader:false,
    roleCode:'',
    deptName:'',
    userId: getUserId(),
    lastLoginDate:'',
    lastLoginTime:'',
    menus: [],
    showDept:false,
    showHDS:false
}

const mutations ={
    SET_TOKEN: (state, token) => {
        state.token = token
    },                                   
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_ROLECODE: (state, roleCode) => {
        state.roleCode = roleCode
    },
    SET_ROLEID: (state, roleId) => {
        state.roleId = roleId
    },
    SET_ISALEADER: (state, isAleader) => {
        state.isAleader = isAleader 
    },
    SET_DEPTNAME: (state, deptName) => {
        state.deptName = deptName 
    },
    SET_ISREG: (state, isReg) => {
        state.isReg = isReg
    },
    SET_SHOWDEPT:(state, showDept) =>{
        state.showDept = showDept
    },
    SET_SHOWHDS:(state, showHDS) => {
        state.showHDS = showHDS
    },
    SET_ROLENAME: (state, roleName) => {
        state.roleName = roleName
    },
    SET_USERID: (state, userId) => {
        state.userId = userId
    },
    SET_LASTLOGINTIME: (state, lastLoginTime) => {
        if(lastLoginTime){
            const time = lastLoginTime.split(' ')
            state.lastLoginDate = time[0]
            state.lastLoginTime = time[1]
        }
        
    },
    SET_MENUS: (state,menus) => {
        state.menus = menus
    }
}

const actions = {
    login({ commit },userInfo){
        return new Promise((resolve,reject) =>{
            login(userInfo).then(response => {
                if(response.code === 0){
                    const { data } = response
                    const token = data.token
                    const userId = data.userId
    
                    commit('SET_TOKEN', token)
                    commit('SET_USERID', userId)
    
                    setToken(token)
                    setUserId(userId)
                }
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getInfo({ commit, state }){
        return new Promise((resolve, reject) => {
            getInfo(state.token).then(response => {
                const { data } = response
                if (!data) {
                    reject('Verification failed, please Login again.')
                }

                const sflag = data.roleCode ==='manager' || verifyStrContain(data.roleCode,'sale')
                const flag = data.roleCode ==='manager' || data.roleCode ==='finance'
                const rflag = data.roleCode ==='manager' || data.roleCode ==='hr'
                commit('SET_ROLECODE', data.roleCode)
                commit('SET_ISALEADER', flag || data.dleader || data.gleader)
                commit('SET_NAME', data.realName)
                commit('SET_ROLEID', data.roleId)
                commit('SET_ROLENAME', data.roleName)
                commit('SET_DEPTNAME', data.deptName != null ? data.deptName : 'PT5外贸管理系统')
                commit('SET_ISREG', data.newReg === 0 ? false : true)
                commit('SET_MENUS', data.menuList)
                commit('SET_LASTLOGINTIME',data.lastLoginTimeStr)
                commit('SET_SHOWDEPT',rflag)
                commit('SET_SHOWHDS',sflag)
            }).catch(error => {
                reject(error)
            })
        })

    },
    logout({ commit, state }){
        return new Promise((resolve, reject) => {
            logout(state.token).then(() => {
                commit('SET_USERID', '')
                commit('SET_TOKEN', '')
                commit('SET_NAME', '')
                commit('SET_ISREG', false)
                commit('SET_MENUS', '')
                commit('SET_LASTLOGINTIME','')
                commit('SET_ROLENAME', '')
                commit('SET_ROLEID', '')
                commit('SET_ISALEADER',false)
                commit('SET_ROLECODE', '')
                commit('SET_DEPTNAME', '')
                commit('SET_SHOWDEPT',false)
                commit('SET_SHOWHDS',false)
                removeToken()
                removeUserId()

                resolve()
            }).catch(error => {
                reject(error)
            })
        })

    },
    resetToken({ commit }){
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_USERID', '')
            removeUserId()
            removeToken()
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}